import React from 'react';

import Api from '../modules/Api';

export default class TermsOfService extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            body: "",
        };
    }

    componentWillMount() {
        Api.getAfterPartyDoc(2, (res) => {
            this.setState({
                body: res.data.body,
            });
        });
    }

    render() {
        const pr = this.props;
        const st = this.state;
        const sty = this.styles;

        return (
            <div
                className="termsOfServiceElement"
                style={sty.termsOfServiceElement}
                {...pr}
                dangerouslySetInnerHTML={{ __html: st.body }}
            >
            </div>
        );
    }

    styles = {
        termsOfServiceElement: {
            width: "100%",
            overflowWrap: "break-word",
            maxHeight:"80%",

        },
    };
}
